<app-kontable
  #serviceTable
  title="{{ 'serviceList.listTitle' | translate }}"
  [columns]="['id', 'name', 'description', 'service_type','flg_direct_active_description']"
  [titles]="['ID', 'serviceList.name', 'serviceList.description', 'serviceList.serviceType','serviceList.directActive']"
  [source]="services"
  [paginationType]="clientPagination"
  [showGlobalFilter]="false"
  [showDetailsButton]="false"
  [showRecoverButton]="false"
  [showAddButton]="true"
  (onAdd)="showAddOrEditDialog($event)"
  (onEdit)="showAddOrEditDialog($event)"
  (onRemove)="deleteService($event)"
  [(fireNewDataAvailable)]="newDataAvailable"
></app-kontable>

<p-dialog
        *ngIf="showAddOrEdit"
        [(visible)]="showAddOrEdit"
        header="{{modalTitle}}"
        [modal]="true"
        [minWidth]="500"
        [draggable]="false"
        [resizable]="false">
  <app-service-form [dataEdit]="editData" (endSaveOrUpdate)="closeDialog($event, serviceTable)">
  </app-service-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/service/service.component.html